import { useCallback } from "react";

import type * as FormModelType from "@/components/features/dialog/re-onboarding-request/model/type";

export const useHandleForm = (
	viewModel: FormModelType.ReOnboardingRequestFormModel["ViewModel"],
	onSetViewModel: (viewModel: FormModelType.ReOnboardingRequestFormModel["ViewModel"]) => void,
) => {
	const handleChangeUpdatedEmail = useCallback(
		(value: string) => onSetViewModel({ ...viewModel, updatedEmail: { ...viewModel.updatedEmail, value: value } }),
		[viewModel, onSetViewModel],
	);

	const handleChangeMessage = useCallback(
		(value: string) => onSetViewModel({ ...viewModel, message: { ...viewModel.message, value: value } }),
		[viewModel, onSetViewModel],
	);

	return {
		handleChangeUpdatedEmail,
		handleChangeMessage,
	};
};
